import { ResponsiveCard } from '../../molecules/card/Card';

export function OsasMraInformationCard() {
    return (
        <ResponsiveCard
            body="Lees meer over de afspraak bij de tandarts, veelvoorkomende bijwerkingen van de beugel en regelmatige controles."
            cardTitle="Beugel (MRA): hoe het werkt"
            lg={12}
            linksText={['Lees meer over hoe de beugel werkt']}
            linksTo={['/osas/mraInformation']}
        />
    );
}
